var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.forceSmall || _vm.property.ContractType.toLowerCase() !== 'priority' || _vm.resolution == 'xs' || _vm.resolution == 'sm')?_c('property-card-single',{attrs:{"property":_vm.property,"favourite":_vm.favourite}}):_c('property-card-double',{attrs:{"property":_vm.property,"favourite":_vm.favourite}})
}
var staticRenderFns = []

export { render, staticRenderFns }